import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/close.svg'
import _imports_1 from '@/assets/img/building_active.png'
import _imports_2 from '@/assets/img/building_off.png'
import _imports_3 from '@/assets/img/location.pin.svg'


const _hoisted_1 = { class: "modal boxContainer d-block" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_3 = { class: "fw_700 mb-0" }
const _hoisted_4 = { class: "searchContainer w-100" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "fw_700 marine mb-3" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  style: {"width":"30px","flex-shrink":"0"},
  class: "mr-3"
}
const _hoisted_10 = {
  key: 0,
  src: _imports_1,
  style: {"width":"23px"}
}
const _hoisted_11 = {
  key: 1,
  src: _imports_2,
  style: {"width":"23px"}
}
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "fw_700 marine mb-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  style: {"width":"30px","flex-shrink":"0"},
  class: "mr-3"
}
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = {
  key: 0,
  class: "fw_700 marine mt-4 mb-3"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"30px","flex-shrink":"0"},
  class: "mr-3"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    style: {"width":"23px"}
  })
], -1)
const _hoisted_21 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_google_autocomplete_get_results = _resolveComponent("google-autocomplete-get-results")!
  const _component_technicians_images = _resolveComponent("technicians-images")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "LuogoBuildingNomeCognome",
          text: "Luogo, building, nome cognome..."
        })
      ]),
      _createElementVNode("img", {
        src: _imports_0,
        class: "pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_google_autocomplete_get_results, {
        inputClass: "fakeInput",
        onChangeAddress: _ctx.changeAddress,
        placeholderKey: "searchHere",
        placeholderText: "Search here...",
        value: _ctx.searchText,
        onInput: _ctx.emitText
      }, null, 8, ["onChangeAddress", "value", "onInput"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.buildingsResults.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Building",
                text: "Building",
                class: "marine"
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildingsResults, (building, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex align-items-center mb-3 pointer",
                key: index,
                onClick: ($event: any) => (_ctx.callbackBuilding(building))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (building.active)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                    : (_openBlock(), _createElementBlock("img", _hoisted_11))
                ]),
                _createElementVNode("h5", _hoisted_12, _toDisplayString(building.bl_id), 1)
              ], 8, _hoisted_8))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.techniciansVehiclesResults.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("h5", _hoisted_14, [
              _createVNode(_component_localized_text, {
                localizedKey: "Tecnici",
                text: "Tecnici",
                class: "marine"
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.techniciansVehiclesResults, (technician, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex align-items-center mb-3 pointer",
                key: index,
                onClick: ($event: any) => (_ctx.callbackTechnician(technician))
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_technicians_images, {
                    role: technician.role,
                    class: "icona"
                  }, null, 8, ["role"])
                ]),
                _createElementVNode("h5", _hoisted_17, _toDisplayString(technician.completeName), 1)
              ], 8, _hoisted_15))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.techniciansVehiclesResults.length > 0 || _ctx.buildingsResults.length > 0)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_18, [
              _createVNode(_component_localized_text, {
                localizedKey: "Luoghi",
                text: "Luoghi",
                class: "marine"
              })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultsList, (addressResult, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex align-items-center mb-3 pointer",
            key: index,
            onClick: ($event: any) => (_ctx.searchCityLocation(addressResult))
          }, [
            _hoisted_20,
            _createElementVNode("h5", _hoisted_21, _toDisplayString(addressResult.description), 1)
          ], 8, _hoisted_19))
        }), 128))
      ])
    ])
  ]))
}